import React from "react";
import { isClient } from "@hackoregon/utils";
import logoCInverted from "../../assets/civic-logo-c-invert.svg";
var styles = {
  height: "60px",
  width: "auto"
};

var CivicLogoCInverted = function CivicLogoCInverted(_ref) {
  var alt = _ref.alt;
  return isClient && React.createElement("img", {
    style: styles,
    src: logoCInverted,
    alt: alt
  });
};

CivicLogoCInverted.displayName = "Logo";
export default CivicLogoCInverted;